import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';

function ColorPickupPopup({ open, close, id, children = null }) {
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        updatePosition();
        window.addEventListener("resize", updatePosition);
        return () => window.removeEventListener("resize", updatePosition);
    }, [open])

    useEffect(() => {
        const handler = (e) => {
            const sidebar = document.querySelector('.hel-sidebar');

            if (!sidebar) return;

            // Only react to sidebar transitions
            if (sidebar.contains(e.target)) {
                updatePosition();
            }
        };

        document.addEventListener('transitionend', handler);
        return () => document.removeEventListener('transitionend', handler);
    }, []);


    const updatePosition = () => {
        const startPostition = document.querySelector(`#${id}`);
        if (startPostition) {
            const newRect = startPostition.getBoundingClientRect();
            setPosition({ left: newRect.left, top: newRect.bottom })
        }
    };

    if (open) {
        return (
            createPortal(
                <div className={"dropdown-menu portal-popup"}
                    onClick={close} >
                    <div className='colour-container' style={{ marginTop: position.top + 10, marginLeft: position.left - 225, "--arrow-top": `${position.top + 5}px`, "--arrow-left": `${position.left + 7}px` }}
                        onClick={(e) => e.stopPropagation()}>
                        {children}
                    </div>
                </div>,
                document.body
            )

        )
    }
}

export default ColorPickupPopup